<template>
  <div>
    <div class="outgoing-detail" v-if="report_supplier_data != null">
      <div
        class="card print"
        v-for="(report_supplier_data, r) in hasil"
        :key="r"
      >
        <table style="width: 100%">
          <thead>
            <!-- HEADER -->
            <div class="card">
              <div class="p-d-flex">
                <div class="p-col-10 p-grid">
                  <div class="p-col-1 image">
                    <img src="/assets/images/logo.png" alt="mode_logo" />
                  </div>
                  <div
                    class="p-col-10"
                    style="margin-top: -10px; margin-left: -5px"
                  >
                    <h4 style="font-size: 15px; line-height: 0.5">
                      <b>MODE FASHION GROUP</b>
                    </h4>
                    <h6 style="font-size: 11px; line-height: 0.5">
                      Jl.Laksana No 68 ABC, Medan
                    </h6>
                    <h6 style="font-size: 11px; line-height: 0.5">
                      Telp. (061) 6643780
                    </h6>
                  </div>
                </div>
              </div>
            </div>
            <div class="border-header" style="margin-bottom: 20px"></div>
            <!-- akhir header -->
          </thead>
          <tbody>
            <h4 class="title" style="margin-bottom: 20px; margin-top: -20px">
              <b style="font-size: 14px">LAPORAN PENDATAAN SUPPLIER</b>
            </h4>

            <div class="p-grid">
              <div class="p-col-12 p-m-auto">
                <!-- header part -->
                <table
                  width="100%"
                  class="d-flex justify-center mt-2 table-tittle"
                >
                  <tr class="grid">
                    <td class="p-col-6" style="font-size: 12px">
                      <!-- <tr>
                          <td style="width: 150px">Nomor Bon</td>
                          <td>: {{ details.summary.doc_number }}</td>
                        </tr> -->
                      <tr>
                        <td style="width: 100px">TANGGAL BON</td>
                        <td>
                          :
                          {{
                            moment(report_supplier_data.date).format(
                              'DD-MM-YYYY'
                            )
                          }}
                        </td>
                      </tr>
                    </td>
                  </tr>
                </table>
                <!-- content part -->
                <table
                  border="1"
                  class="text-center detail-bon"
                  style="width: 100%"
                >
                  <thead style="font-size: 12px">
                    <tr style="background-color: grey">
                      <th scope="col" class="text-center" rowspan="2">No</th>
                      <th scope="col" class="text-center" rowspan="2">
                        Kode Supplier
                      </th>
                      <th scope="col" class="text-center" rowspan="2">
                        Nama Supplier
                      </th>
                      <th scope="col" class="text-center" rowspan="2">
                        Tanggal
                      </th>
                      <th scope="col" class="text-center" rowspan="2">Stock</th>
                      <th scope="col" class="text-center" rowspan="2">
                        Qty Masuk
                      </th>
                      <th scope="col" class="text-center" rowspan="2">
                        Qty Terjual
                      </th>
                      <th scope="col" class="text-center" rowspan="2">
                        Qty Retur
                      </th>
                      <th scope="col" class="text-center" rowspan="2">
                        Qty Transfer
                      </th>
                    </tr>
                  </thead>
                  <tbody style="font-size: 12px" class="header">
                    <tr
                      v-for="(item, k) in report_supplier_data"
                      :key="r * 15 + k + 1"
                      class="row-content"
                    >
                      <td>{{ r * 15 + k + 1 }}</td>
                      <td>{{ item.supplier_code }}</td>
                      <td>{{ item.supplier_name }}</td>
                      <td>{{ item.date }}</td>
                      <td>{{ item.stock }}</td>
                      <td>{{ item.qty_in }}</td>
                      <td>{{ item.qty_sell }}</td>
                      <td>{{ item.qty_retur }}</td>
                      <td>{{ item.qty_transfer }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
var moment = require('moment')
export default {
  data() {
    return {
      report_supplier_data: null,
      moment: moment,
      loading: true,
      products: null,
      expandedRows: [],
      confirmDialog: false,
      ModeLogo: undefined,
      rowIndex: 0,
      mutation_code: null,
      hasil: []
    }
  },
  mounted() {
    // this.$forceUpdate()
    this.getReportSupplier()
  },
  methods: {
    async getReportSupplier() {
      this.loading = true

      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/dashboard/supplier_report?start_date=${this.$route.query.start_date}&end_date=${this.$route.query.end_date}&page=${this.$route.query.page}&limit=${this.$route.query.limit}`
        )
        if (response.status === 200) {
          this.report_supplier_data = response.data.data.supplier_data
          this.buildDetail()
          setTimeout(() => {
            window.print()
          }, 500)

          window.onafterprint = () => {
            window.history.back()
          }
        } else {
          this.showToast('error', 'Error', 'Gagal mengambil data')
        }
      } catch (error) {
        this.showToast(
          'error',
          'Error',
          'Terjadi kesalahan saat mengambil data'
        )
        console.error('Error fetching report refund:', error)
      } finally {
        this.loading = false
      }
    },
    buildDetail() {
      this.splitLength()
    },
    splitLength() {
      if (this.report_supplier_data && this.report_supplier_data.length > 0) {
        for (
          let i = 0;
          i < Math.ceil(this.report_supplier_data.length / 25);
          i++
        ) {
          this.hasil[i] = []
          for (let j = 0; j < 25; j++) {
            if (this.report_supplier_data[this.rowIndex]) {
              this.hasil[i][j] = this.report_supplier_data[this.rowIndex]
              this.rowIndex++
            }
          }
        }
      } else {
        console.error('Report supplier data is empty or undefined.')
      }
    }
  }
}
</script>

<style scoped lang="scss">
table {
  -fs-table-paginate: paginate;
}

table thead th {
  border: 1px solid black;
}

.container {
  font-family: monospace;
  width: 100%;
  margin-top: -50px;
  margin-left: auto; /* to center the div */
  margin-right: auto; /* to center the div */
  box-sizing: border-box;
  overflow: hidden;
}

.border-header {
  border-top: 2px solid black;
  width: 95%;
  margin-top: -4vh;
  margin-left: auto;
  margin-right: auto;
  justify-content: center;
}

.image {
  margin-top: -7px;
  width: 63px;
}

.title {
  text-align: center;
}

.outgoing-detail {
  font-family: monospace;
  width: 100%;
  margin-top: -50px;
  margin-left: auto; /* to center the div */
  margin-right: auto; /* to center the div */
  box-sizing: border-box;
  overflow: hidden;
}

.table-tittle {
  margin-top: -10px;
}

@media print {
  .border-header {
    margin-top: -35px;
  }
  .table-tittle {
    margin-top: -15px !important ;
  }
  .detail-bon {
    border: 1px solid black;
    border-collapse: collapse;
    font-size: x-small;
    margin-bottom: 30px;
  }

  .detail-bon th,
  .detail-bon td {
    border: 1px solid black;
    padding: 1px;
  }

  .print table thead {
    display: table-header-group;
  }

  .print:nth-child(1n) {
    page-break-after: always;
  }
}
</style>
